module.exports = __webpack_public_path__ + "static/media/tipsease.020ca53a.jpg";